import axios from 'axios';
import {
  MessageBox
} from 'element-ui';

/**
 * 封装fetch
 * @param path
 * @param params
 * @returns {*|Promise|Promise.<T>|Promise<U>}
 */
export default function toFetch(path, params, config) {
  let {
    //TODO:
    url = process.env.VUE_APP_ENV == 'development' ? '' : process.env.VUE_APP_ENV == 'pre' ? '//gapi.dev.ztgame.com' : '//gapi.ztgame.com',
    type = 'POST',
    contextType = 'application/json'
  } = config || {};

  url = `${url}${path}`;


  return axios(type === 'POST' ? {
    method: type,
    url,
    withCredentials: true,
    headers: {
      'Content-Type': contextType
    },
    data: params
  } : {method: type, url, withCredentials: true})
    .then(res => {
      if (res.data.code != 1) {
        if (res.data.errors) {
          let keys = Object.keys(res.data.errors)
          if (res.data.errors[keys[0]]) {
            MessageBox.alert(res.data.errors[keys[0]][0], '提示', {
              confirmButtonText: '确定'
            });
          }
        }
      } else {
        return res.data;
      }
    })
    .catch(function (err) {
      MessageBox.alert(err.message, '提示', {
        confirmButtonText: '确定'
      });
      return {}
    })
}
